export const centimeterScale = 1;
export const cm = (value: number) => value * centimeterScale;
